import { BasketItem } from "./BasketItem";

function BasketList(props) {
  const {
		order = [],
		deleteFromBasket = Function.prototype,
		incrementItem = Function.prototype,
		decrementItem = Function.prototype,
		totalPrice = 0,
		orderListVisibility = Function.prototype,
  } = props;

  return (
		<ul className='collection basket-list'>
			<li className='collection-item active'>Корзина</li>
			{order.length ? (
				order.map(item => {
					return (
						<BasketItem
							key={`${item.mainId}-${item.offerId}`}
							{...item}
							deleteFromBasket={deleteFromBasket}
							incrementItem={incrementItem}
							decrementItem={decrementItem}
						/>
					);
				})
			) : (
				<li className='collection-item'>Корзина пуста</li>
			)}
			<li className='collection-item active'>
				<span>Общая стоимость: {totalPrice}</span>
				<button className='waves-effect waves-light btn purchase-btn'>Оформить заказ</button>
			</li>
			<i
				className='material-icons basket-close'
				onClick={orderListVisibility}
			>
				close
			</i>
		</ul>
  );
}

export { BasketList };